/**
 * LightboxLink handles all links that should
 * open a page in a lightbox (tertiary pages)
 */
export default class LightboxLink {

    constructor() {
        if (Modernizr.history) {
            this.loadingOverlay = $('.loading-overlay');
            this.scrollPos = $(window).scrollTop();
            this.setEventListeners();
        }
    }


    setEventListeners() {
        let t = this;
        $(document).on('click', '.lightbox-link', function(e) {
            t.triggerLink(t, $(this), e);
        });
    }

    /**
     * Get data from clicked link and begin
     * the transition
     * @param t - LightboxLink instance
     * @param el - link clicked (jQuery element)
     * @param e - event from click
     */
    triggerLink(t, el, e) {
        e.preventDefault();
        e.stopPropagation();

        // New page data
        let newData = {
            href: el.attr('href'),
            title: el.attr('title'),
            subtitle: el.attr('data-subtitle')
        };
        // Check the new URL
        window.App.checkURL(); 
        // Show loading overlay
        t.loadingOverlay.addClass('active');
        // Load new page data
        t.getData(newData.href, newData.title, newData.subtitle);
    }


    /**
     * Get the data for the new page
     * @param url
     * @param title
     * @param subtitle
     */
    getData(url, title, subtitle) {
        let t = this;
        let newPage = $('<div class="new-page"></div>');
        let returnData = {
            page: null,
            url: url,
            title: title,
            subtitle: subtitle,
            success: false,
        };

        newPage.load(url + " .lightbox-link-content", function(response, status, xhr) {
            returnData.page = newPage;
            returnData.success = (status !== 'error');
            returnData.response = response;
            if (returnData.success) {
                return (xhr.status === 200) ? t.show(returnData) : window.Pages.forceRedirect(url);
            } else {
                window.Pages.forceRedirect(url);
            }  
        });
    }


    /**
     * Update the history and page content
     * @param pageData
     * @param pushHistory
     * @returns {*}
     */
    show(pageData) {
        // Update page data
        this.updateLightboxData(pageData);
        // Send google analytics
        window.Pages.sendAnalytics(pageData.url);
        return true;
    }

    /**
     * Add the new page content to the lightbox and show
     * it.
     * @param pageData
     */
    updateLightboxData(pageData) {
        let t = this;
        // Get content from page
        let content = $(pageData.response).find(".lightbox-link-content").html();
        if (content.length <= 0) {
            content = $("<h2 class='text-center'>Page Not Found</h2>");
        }
        let html = `
            <div class="content">
                `+content+`
            </div>
        `;

        // Capture current scroll position
        t.scrollPos = $(window).scrollTop();

        // Update #page-content with new html
        pageData.page.imagesLoaded( {background:true}, function() {
            // Open lightbox (featherlight.js)
            $.featherlight(html,{
                beforeOpen() {
                    // Remove loading overlay
                    t.loadingOverlay.removeClass('active');
                },
                afterOpen() {
                    // Re-initialize classes
                    window.App.reInitialize();
                    t.backToTopButton();
                },
                afterClose() {
                    // Set scroll position back to where the link was clicked
                    setTimeout(() => {
                        $(window).scrollTop(t.scrollPos);
                    }, 0);
                }
            });
        });
        return true;
    }
    
    
    backToTopButton(){
        let backToTop = $('<div id="back-to-top"><span class="icon-back"></span></div>');
        $('.featherlight-content .featherlight-close').
            after(backToTop);
        $('.featherlight-content').scroll(function() {
            if ($(this).scrollTop() >= 50) {        // If page is scrolled more than 50px
                backToTop.fadeIn(200);    // Fade in the arrow
            } else {
                backToTop.fadeOut(200);   // Else fade out the arrow
            }
        });
        backToTop.click(function() {      // When arrow is clicked
            $('.featherlight-content').animate({
                scrollTop : 0                       // Scroll to top of body
            }, 500);
        });
    }
}


// WEBPACK FOOTER //
// ./public/js/LightboxLink.js